import React, { useEffect } from 'react'
import { BOOK_TITLES, SEO, SITE_URL } from '../../constants';
import { SectionClub } from './section-club/section-club';
import { SectionAbout } from './section-about/section-about';
import { SectionStack } from './section-stack/section-stack';
import { SectionPortfolio } from './section-portfolio/section-portfolio.jsx';
import { SectionWhyMe } from './section-why-me/section-why-me';
import { SectionContacts } from './section-contacts/section-contacts.jsx';
import { SectionFAQ } from './section-faq/section-faq';
import { SectionDivider } from '../divider';


import { useSEO } from '../../hooks/useSEO';

export const PageClub = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Handle hash navigation
    const hash = window.location.hash;
    if (hash) {
      const element = document.getElementById(hash.slice(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      }
    }
  }, []);

  const seo = {
    ...SEO.club,
    schemaLD: {
      "@context": "https://schema.org",
      "@type": "Club",
      "name": "Нормальный книжный клуб",
      "description": "Книжный клуб — обсуждаем классику и современную литературу, развиваем критическое мышление и системное понимание.",
      "url": SITE_URL,
      "image": `${SITE_URL}/og-image-club.png`,
      "founder": {
        "@type": "Person",
        "name": "Мария Бурлакова",
        "jobTitle": "Руководитель разработки", 
      },
      "member": {
        "@type": "Group",
        "name": "Любители книг"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Книги для обсуждения",
        "itemListElement": Object.entries(BOOK_TITLES).map(([key, title], index) => ({
          "@type": "Offer",
          "position": index + 1,
          "itemOffered": {
            "@type": "Book",
            "name": title
          }
        }))
      }
    }
  };

  useSEO(seo);

  return (
    <div>
      <SectionClub />
      <SectionDivider />
      <SectionAbout />
      <SectionDivider />
      <SectionStack />
      <SectionDivider />
      <SectionWhyMe />
      <SectionDivider />
      <SectionContacts />
      <SectionDivider />
      <SectionPortfolio />
      <SectionDivider />
      <SectionFAQ />
    </div>
  )
}
